import languagesReducer from "./reducers";
export { default as languagesTypes } from "./types";
export { default as languagesOperations } from "./operations";
export default languagesReducer;
